import React, { Fragment, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../Services/translation';
import { getCatalog, toggleModalMessage } from '../Actions/OnlineCatalog.action';
import Modal from 'react-foundation-modal';

const OnlineCatalogDownloadButton = props => {
    const revealStyle = {
        'position': 'fixed',
        'padding': '2rem',
        'top': '40%',
        'left': '50%',
        'zIndex': '11',
        'marginLeft': '-150px',
        'maxHeight': '90%',
        'backgroundColor': 'rgba(255, 255, 255, 0.98)',
        'borderRadius': '0.3rem',
        'border': '1px solid rgba(0, 0, 0, 0.4)',
        'boxShadow': 'rgb(0 0 0 / 35 %) 0px 0px 13px 0px',
        'display': 'block',
        'width': '100%',
        'maxWidth': "300px",
        'overflowY': 'auto',
        'textAlign': 'center'
    }

    const overlayStyle = {
        'backgroundColor': 'rgba(197,193,186,.76)',
        'display': 'block',
        'height': '100vh',
        'width': '100vw',
        'position': 'fixed',
        'top': '0',
        'left': '0',
        'zIndex': '1000',
    };

    const closeStyle = {
        'display': 'none'
    };

    const closeButtonStyle = {
        'position': 'absolute',
        'right': '10px',
        'top': '10px',
        'cursor': 'pointer'
    };

    //const [modalIsOpen, setModalIsOpen] = React.useState(false);
    //const [modalMessage, setModalMessage] = React.useState("");
    const buttonEl = useRef(null);

    const closeModal = () => {
        const { toggleModalMessage } = props;

        if (toggleModalMessage) {
            toggleModalMessage('', false);
        }
    }

    const getTheCatalog = () => {
        const { toggleModalMessage } = props;
        if (toggleModalMessage) {
            toggleModalMessage("TEST", true);
        }
        const { getCatalog } = props;
        if (getCatalog) {
            getCatalog();
        }
    }

    const { showModal, modalMessage, pages } = props;

    return (
        <Fragment>

            <button className="online-catalog__button" ref={buttonEl} onClick={() => getTheCatalog()}>DOWNLOAD</button>

            <Modal
                open={showModal}
                closeModal={() => closeModal()}
                overlayStyle={overlayStyle}
                revealStyle={revealStyle}
                size="large"
                isModal={true}
                closeStyle={closeStyle}>

                <button style={closeButtonStyle} onClick={() => closeModal()}>
                    {translate('common.columbus.modal.close')} <i className="fas fa-times-circle"></i>
                </button>
                <div>
                    {modalMessage || 'hepp'}
                </div>
            </Modal>
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        showModal: state.onlineCatalog.showModal,
        modalMessage: state.onlineCatalog.modalMessage,
        pages: state.onlineCatalog.pages,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCatalog: () => dispatch(getCatalog()),
        toggleModalMessage: (message, isOpen) => dispatch(toggleModalMessage(message, isOpen))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OnlineCatalogDownloadButton);